import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from 'material-ui';

const CheckedIcon = props => (
  <SvgIcon {...props} viewBox='0 0 24 24' style={{ height: 24, width: 24 }}>
    <g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='check_filled' transform='translate(1.000000, 1.000000)'>
        <circle
          id='Oval-3-Copy-2'
          stroke={props.color || '#2974FF'}
          strokeWidth='2'
          fill={props.color || '#2974FF'}
          cx='11'
          cy='11'
          r='11'
        />
        <path
          d='M6.25775631,12.1576824 C5.91408123,11.7946822 5.91408123,11.2043446 6.25775631,10.8413807 C6.59914609,10.4807942 7.1509409,10.4807831 7.49228772,10.8413963 L9.3097904,12.7612908 L14.5077175,7.27049459 C14.8491081,6.90983513 15.4009369,6.90983513 15.7422933,7.2704946 C16.0858992,7.63349435 16.0859099,8.22379538 15.7422794,8.58674846 L9.92708823,14.7295853 C9.58583902,15.0900955 9.03378538,15.0901824 8.69249056,14.7295812 L6.25775631,12.1576824 Z M9.25245566,13.8902966 C9.26918754,13.9073752 9.29838658,13.9073712 9.3151621,13.8902515 L15.2198527,7.8649829 C15.2344158,7.85012404 15.2344154,7.82780112 15.2198076,7.81289369 C15.2029585,7.79569716 15.1739843,7.79569716 15.1571044,7.81292337 L9.28378776,13.8061795 L8.98608529,13.5023996 L6.84290201,11.3154644 C6.82605564,11.2982724 6.79704697,11.298273 6.78015268,11.3155105 C6.76558512,11.3303724 6.76558512,11.3526595 6.78018275,11.3675536 L9.25241055,13.8902506 L8.95470907,14.2 L9.25245566,13.8902966 Z'
          id='Fill-1-Copy'
          stroke='#FFFFFF'
          strokeWidth='0.5'
          fill='#FFFFFF'
          fillRule='nonzero'
        />
      </g>
    </g>
  </SvgIcon>
);

CheckedIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default CheckedIcon;



// WEBPACK FOOTER //
// ./src/icons/CheckedIcon.js